import { useGlobal } from "kanopi-components/useGlobal";

/**
 * Return current user.
 */
export const useUser = () => {
  const [auth] = useGlobal("auth");
  const user: TUser | undefined = auth?.user;
  return user;
};
